var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"bv-modal-help","title":_vm.$t('Help'),"ok-only":"","centered":"","size":"lg","hide-footer":"","no-close-on-esc":"","no-close-on-backdrop":""}},[_c('h4',[_vm._v("-> "+_vm._s(_vm.$store.state.helpTitle))]),_c('br'),_c('p',{staticClass:"preserve-newline"},[_vm._v(" "+_vm._s(_vm.$store.state.helpText)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }